import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function MoneyIcon(props: IIcon) {
    const newViewProps = '0 -512 512 512' ?? props.viewBox;
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={newViewProps}
            style={props.style}
            className={props.className}
        >
            <path
                transform="scale(1,-1)"
                d="M433 295v-150h-146c20 15 34 43 34 75s-14 60 -34 75h146v0zM217 295c-20 -15 -33 -43 -33 -75s13 -60 33 -75h-146v150h146zM488 82h-472c-9 0 -16 7 -16 16v244c0 9 7 17 16 17h472c9 0 16 -8 16 -17v-244c0 -9 -7 -16 -16 -16zM32 114h440v212h-440v-212z"
            ></path>
        </Icon>
    );
}
